module.exports = __webpack_public_path__ + "static/media/Capex.7b0a3b4a.svg";